import React from "react";
import { FaTimes } from "react-icons/fa";

const Donate = ({ onClose }) => {
  const handleDonateClick = () => {
    window.open(
      "https://www.payway.com.au/MakePayment?BillerCode=275255",
      "_blank"
    );
  };

  return (
    <div
      className="modal"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"
      }}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: "white",
          padding: "30px",
          borderRadius: "10px",
          width: "800px",
          minHeight: "400px",
          maxHeight: "80vh",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
          position: "relative",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <FaTimes
          onClick={onClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            fontSize: "18px",
            cursor: "pointer",
            color: "black",
            fontWeight: "100",
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "20px",
            paddingBottom: "15px",
            borderBottom: "1px solid #ccc",
            gap: "40px"
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "1.8rem",
              color: "#333",
            }}
          >
            Seeking Community Support
          </h2>
          <button
            onClick={handleDonateClick}
            style={{
              backgroundColor: "#007bff",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: "500"
            }}
          >
            Donate Now
          </button>
        </div>
        <div
          style={{
            overflowY: "auto",
            flex: 1,
            paddingRight: "10px",
            lineHeight: "1.6",
            fontSize: "16px",
            color: "#333",
            textAlign: "left"
          }}
        >
          <p style={{ marginBottom: "20px" }}>
            Donations received are a testament to the generosity of the community in supporting the expansion of UrCommunity and UrVote, enabling us to extend our unique models and services further.
          </p>
          <p style={{ marginBottom: "30px" }}>
            UrCommunity is a Registered Charity and Not for Profit (NFP) with Deductible Gift Recipient (DGR) 1 status. We believe that individuals and others within the broader community may wish to contribute based on their personal experiences or through learning about our impactful work via social media, community networking, or other means.
          </p>

          <h3 style={{ fontSize: "1.5rem", marginBottom: "15px", color: "black" }}>How Do We Use Donated Money?</h3>
          <p style={{ marginBottom: "20px" }}>
            Donations to UrCommunity help sustain and grow our community-centric initiatives, including:
          </p>
          <ul style={{ paddingLeft: "20px", marginBottom: "20px" }}>
            <li>
              <strong>Food Security:</strong> Providing free and low-cost meals to the community.
            </li>
            <li>
              <strong>First Step Program:</strong> Empowering those who are between jobs or long-term unemployed, to receive skill development and meaningful work opportunities.
            </li>
            <li>
              <strong>Local Projects:</strong> Facilitating inclusive discussions, educational programs, and initiatives that promote community engagement and resilience.
            </li>
          </ul>

          <h3 style={{ fontSize: "1.5rem", marginBottom: "15px", color: "black" }}>Tax Deductibility and Receipts</h3>
          <p style={{ marginBottom: "20px" }}>
            Donations of $2 or more are tax-deductible. A receipt will be issued for every donation received.
          </p>
          <p style={{ marginBottom: "20px" }}>
            Thank you for your continued generosity and support in helping us make a difference.
          </p>

          <h3 style={{ fontSize: "1.5rem", marginBottom: "15px", color: "black" }}>Fundraising Registration Details</h3>
          <p style={{ marginBottom: "10px" }}><strong>ABN:</strong> 51601224908</p>
          <ul style={{ paddingLeft: "20px", marginBottom: "20px", listStyle: "none" }}>
            <li style={{ marginBottom: "8px" }}><strong>VIC:</strong> FR0015777</li>
            <li style={{ marginBottom: "8px" }}><strong>NSW:</strong> CFN/25144</li>
            <li style={{ marginBottom: "8px" }}><strong>ACT:</strong> Registered with ACNC</li>
            <li style={{ marginBottom: "8px" }}><strong>QLD:</strong> CH3326</li>
            <li style={{ marginBottom: "8px" }}><strong>NT:</strong> Registered with ACNC</li>
            <li style={{ marginBottom: "8px" }}><strong>TAS:</strong> Registered with ACNC</li>
            <li style={{ marginBottom: "8px" }}><strong>SA:</strong> Registered with ACNC</li>
          </ul>

          <p style={{ marginBottom: "20px", fontSize: "16px" }}>
            For any donation inquiries, please call us on <strong>1300 653 185</strong> between 10am and 5pm, Monday to Friday.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Donate;
 